// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"2506af3b","453":"31c9641a","455":"fed288c0","749":"bb4dc471","903":"abb35f75"}[chunkId] + ".chunk.js";
};